import { render, staticRenderFns } from "./itensNDispensados.vue?vue&type=template&id=2f62d053"
import script from "./itensNDispensados.vue?vue&type=script&lang=js"
export * from "./itensNDispensados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports